import { render } from "./Circulation.vue?vue&type=template&id=6823d482&scoped=true"
import script from "./Circulation.vue?vue&type=script&lang=js"
export * from "./Circulation.vue?vue&type=script&lang=js"

import "./Circulation.vue?vue&type=style&index=0&id=6823d482&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6823d482"]])

export default __exports__